import React from "react";
import { Link } from "react-router-dom";

/**
 * Editorial event tile: title above the rectangle (per brief),
 * image + blurb inside the rectangle, gold-framed.
 *
 * Active tiles link straight to the relevant enquiry form (external HTML route).
 * Inactive tiles route to /coming-soon/:slug.
 */
export const EventTile = ({ event, index = 0 }) => {
  const ariaLabel = event.active
    ? `Enquire about ${event.title}`
    : `${event.title} — coming soon`;

  const inner = (
    <>
      <div className="sc-tile-frame">
        <div
          className="sc-tile-image"
          style={{ backgroundImage: `url(${event.image})` }}
          aria-hidden="true"
        />
        {!event.active && (
          <div className="sc-tile-overlay">
            <span className="sc-tile-badge">COMING SOON</span>
          </div>
        )}
        {event.isPlaceholder && (
          <span
            className="sc-tile-stock-tag"
            data-testid={`event-tile-stock-tag-${event.slug}`}
            style={{
              position: "absolute",
              left: 10,
              bottom: 10,
              padding: "3px 8px",
              fontSize: 9,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              color: "#fff",
              background: "rgba(34,34,34,0.62)",
              backdropFilter: "blur(2px)",
              fontStyle: "italic",
              fontWeight: 500,
              pointerEvents: "none",
            }}
          >
            Stock image
          </span>
        )}
        <div className="sc-tile-body">
          <p className="sc-tile-blurb">{event.blurb}</p>
          <span className="sc-tile-cta">
            {event.active ? "BEGIN ENQUIRY →" : "NOTIFY ME →"}
          </span>
        </div>
      </div>
    </>
  );

  const wrapperProps = {
    className: "sc-tile",
    "data-testid": `event-tile-${event.slug}`,
    "aria-label": ariaLabel,
    style: { "--tile-index": index },
  };

  return (
    <article {...wrapperProps}>
      <header className="sc-tile-header">
        <span className="sc-tile-number">
          {String(index + 1).padStart(2, "0")}
        </span>
        <h3 className="sc-tile-title">{event.title}</h3>
      </header>

      {event.active ? (
        <a
          href={event.href}
          className="sc-tile-link"
          data-testid={`event-tile-link-${event.slug}`}
        >
          {inner}
        </a>
      ) : (
        <Link
          to={`/coming-soon/${event.slug}`}
          className="sc-tile-link"
          data-testid={`event-tile-link-${event.slug}`}
        >
          {inner}
        </Link>
      )}
    </article>
  );
};

export default EventTile;
